import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-confirm',
    templateUrl: './dlg-confirm.component.pug',
    styleUrls: ['./dlg-confirm.component.less'],
})
export class DlgConfirmComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<DlgConfirmComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
    }

    onConfirm() {
        this.dialogRef.close(true);
    }

    onCancel() {
        this.dialogRef.close(false);
    }

}
